module.exports = __webpack_public_path__ + "img/ac23412.png";